import React from 'react';
import Link from 'next/link';
import classNames from 'classnames';
import styles from './Sidebar.module.css';

function SidebarItem({
  left,
  center,
  right,
  onClick,
  onClickCenter,
  link,
  className,
  selected,
  containerClassname,
  disabled,
}: {
  left?: any;
  center: any;
  right?: any;
  onClick?: () => void;
  onClickCenter?: () => void;
  link?: string;
  className?: string;
  selected?: boolean;
  containerClassname?: string;
  disabled?: boolean;
}) {
  return link ? (
    (
      <Link href={link} legacyBehavior>

        <div
          className={classNames(
            styles.containerItem,
            {
              [styles.containerHoverable]: !disabled,
              [styles.containerSelected]: selected,
            },
            containerClassname,
          )}
          onClick={onClick}
        >
          <div className={left && styles.leftItem}>{left}</div>
          <div
            className={classNames(styles.centerItem, className)}
            onClick={onClickCenter}
          >
            {center}
          </div>
          <div className={styles.right}>{right}</div>
        </div>

      </Link>
    )
  ) : (
    <div
      className={classNames(
        styles.containerItem,
        {
          [styles.containerHoverable]: !disabled,
          [styles.containerSelected]: selected,
        },
        containerClassname,
      )}
      onClick={onClick}
    >
      <div className={left && styles.leftItem}>{left}</div>
      <div
        className={classNames(styles.centerItem, className)}
        onClick={onClickCenter}
      >
        {center}
      </div>
      <div className={styles.right}>{right}</div>
    </div>
  );
}

export default SidebarItem;
